export const apiURL = 'https://admin.seospace.co:4242';
export const COOKIE_NAME = 'SEOSpaceAdminLogging';
